import React from 'react';
import sensorService from '../../services/sensor-service';
import { getCurrentUser } from '../../utils/auth';
import { farsiDigits } from '../../utils/sanitaize';

export default class SidebarBase extends React.Component {

  state = {
    alarmedSensors: []
  }

  componentDidMount = async () => {
    const { _id } = getCurrentUser();
    const alarmedSensors = await sensorService.fetchAlarmedSensor(_id);
    this.setState({ alarmedSensors });
  }

  getBadge = () => {
    const { alarmedSensors } = this.state;
    const length = alarmedSensors.length;
    if (length === 0) {
      return {};
    }
    return { badge: { text: farsiDigits(length.toString()), background: '#E74C3C' } }
  }
}
